import React from 'react';
import { Link } from '@framework/router/Next/Link';
import cn from 'classnames';

import BookDemoButton from '@/evercall/ui/common/BookDemoButton';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';

import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';
import styles from './startActions.module.scss';

const StartActions = () => (
  <div className={ styles.actionsWrp }>
    <BookDemoButton className={ cn(styles.actionButton, styles.bookDemoButton) } />
    <span className={ styles.buttonsDivider }>or</span>
    <Link to="/schedule">
      <Button
        variant={ ButtonVariantType.action }
        className={ cn(styles.actionButton, styles.scheduleEventButton, spacesStyles.mrn) }
        title="Schedule Your Event"
        dataTest="scheduleEventButton"
      />
    </Link>
  </div>
);

export default StartActions;
